
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/whatsapp-business-pricing-July-2025-update",
      function () {
        return require("private-next-pages/whatsapp-business-pricing-July-2025-update.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/whatsapp-business-pricing-July-2025-update"])
      });
    }
  